import { inject, Injectable } from '@angular/core';

import { AssistantRunService } from './run/assistant-run.service';
import { TellentAssistantThreadsFacade } from './tellent-assistant-threads.facade';

@Injectable({ providedIn: 'root' })
export class TellentAssistantFacade {
  private readonly run = inject(AssistantRunService);
  private readonly threads = inject(TellentAssistantThreadsFacade);

  public readonly messages = this.run.messages;
  public readonly runStatus = this.run.runStatus;
  public readonly currentThreadId = this.run.currentThreadId;
  public readonly lastError = this.run.lastError;

  public send(text: string): void {
    this.run.send(text);
  }

  public cancelRun(): void {
    this.run.cancelRun();
  }

  public newThread(): void {
    this.run.cancelRun();
    this.run.resetForThread(crypto.randomUUID());
  }

  public switchThread(id: string): void {
    this.run.cancelRun();
    this.run.resetForThread(id);
    this.threads.loadCurrent(id);
  }
}
